<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula Fundamental</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Dados da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula: </label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>

                  <v-row v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'">
                    <v-col cols="12">
                      <ValidationProvider
                        name="Horário da aula"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-autocomplete
                          :items="horariosFiltrados"
                          outlined
                          prepend-inner-icon="mdi-clock-outline"
                          label="Selecione o horário"
                          :error-messages="errors"
                          :item-text="(item) => item.descricao"
                          v-model="horarioSelecionado"
                          return-object
                          dense
                          clearable
                          @change="verificarConflitoAula"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <div v-for="(dup, dupIndex) in duplicacoesAdicionais" :key="dup._key">
                <v-card outlined class="mb-4">
                  <v-card-title class="subtitle-2 primary--text py-2 px-4">
                    Aula {{ dupIndex + 2 }}
                    <v-spacer />
                    <v-btn icon x-small color="error" @click="removerDuplicacao(dupIndex)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-dialog v-model="dup.modal" width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <e-label>Data da Aula</e-label>
                            <v-text-field
                              dense
                              outlined
                              v-model="dup.dataDisplay"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="dup.data"
                            :allowed-dates="allowedDates"
                            scrollable
                            locale="pt-BR"
                          >
                            <v-spacer />
                            <v-btn text color="error" @click="dup.modal = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="confirmarDataDuplicacao(dupIndex)"
                              >Confirmar</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-row v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'">
                      <v-col cols="12">
                        <e-autocomplete
                          :items="dup.horariosFiltrados"
                          outlined
                          prepend-inner-icon="mdi-clock-outline"
                          label="Selecione o horário"
                          :item-text="(item) => item.descricao"
                          :value="dup.horario"
                          return-object
                          dense
                          clearable
                          @change="(val) => selecionarHorarioDuplicacao(dupIndex, val)"
                        />
                      </v-col>
                    </v-row>
                    <v-alert v-if="dup.temConflito" dense outlined type="warning" class="mt-2 mb-0">
                      Conflito de horário detectado para esta data.
                    </v-alert>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Botão Adicionar Aula -->
              <div class="d-flex align-center mb-6">
                <v-btn
                  color="primary"
                  depressed
                  small
                  :disabled="limiteAtingido"
                  @click="adicionarDuplicacao"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  ADICIONAR AULA
                </v-btn>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>O LIMITE MÁXIMO PARA DUPLICAÇÃO DE AULA SÃO DE 5 AULAS.</span>
                </v-tooltip>
                <span
                  v-if="limiteAtingido"
                  class="ml-3 error--text text-caption font-weight-medium"
                >
                  VOCÊ ATINGIU O LIMITE DE 5 AULAS
                </span>
              </div>

              <div v-if="aulaDuplicada.e_aula_infantil">
                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Estratégias de Ensino
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.estrategias"></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Recursos
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.recursos"></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Atividade de Casa
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.atividade_casa"></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Observações
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.observacoes"></div>
                  </v-card-text>
                </v-card>
              </div>

              <div v-else>
                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Unidades Temáticas
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div
                      v-if="unidadesTematicasTexto"
                      class="content-box"
                      v-html="formatTexto(unidadesTematicasTexto)"
                    />
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Objetos de Conhecimento
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div
                      v-if="objetosConhecimentoTexto"
                      class="content-box"
                      v-html="formatTexto(objetosConhecimentoTexto)"
                    />
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Habilidades
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div
                      v-if="habilidadesTexto"
                      class="content-box"
                      v-html="formatTexto(habilidadesTexto)"
                    />
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Objetivo de Aprendizagem
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.objetivo_de_aprendizagem"></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Procedimentos Metodológicos
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div
                      class="content-box"
                      v-html="aulaDuplicada.procedimentos_metodologicos"
                    ></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Material de Apoio
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.material_de_apoio"></div>
                  </v-card-text>
                </v-card>

                <v-card outlined class="mb-6">
                  <v-card-title class="subtitle-1 font-weight-bold primary--text">
                    Avaliação da Aula
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="content-box" v-html="aulaDuplicada.avaliacao_da_aula"></div>
                  </v-card-text>
                </v-card>
              </div>
              <v-divider class="my-6"></v-divider>
              <e-progresso-preenchimento
                :expectedItems="itemsProgresso"
                :filledItems="itemsPreenchidos"
                @total-filled-changed="
                  (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                "
                :isInfantil="aulaDuplicada.e_aula_infantil === 1"
              />

              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  depressed
                  :disabled="
                    !totalmentePreenchido ||
                    temConflito ||
                    duplicacoesAdicionais.some((d) => d.temConflito)
                  "
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>
<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
  },
  data() {
    return {
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosFiltrados: [],
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      messageAlert: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: null,
      itemsEsperados: [
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      duplicacoesAdicionais: [],
    };
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        this.horariosFiltrados = [];
        return;
      }
      this.horarioSelecionado = null;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
    },
    dialog: {
      handler(val) {
        if (!val) {
          this.dataAulaDuplicada = null;
          this.data = null;
          this.horarioSelecionado = { descricao: "Escolha um horario" };
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.messageAlert = null;
          this.duplicacoesAdicionais = [];
          this.itemsPreenchidos = [];
        }
      },
    },
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  methods: {
    adicionarDuplicacao() {
      if (this.limiteAtingido) return;
      const key = Date.now();
      const idx = this.duplicacoesAdicionais.length;
      this.duplicacoesAdicionais.push({
        _key: key,
        modal: false,
        data: null,
        dataDisplay: null,
        horario: null,
        horariosFiltrados: [],
        temConflito: false,
      });
    },
    removerDuplicacao(idx) {
      this.duplicacoesAdicionais.splice(idx, 1);
    },
    confirmarDataDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data) return;
      this.$set(this.duplicacoesAdicionais[idx], "horario", null);
      this.$set(this.duplicacoesAdicionais[idx], "temConflito", false);
      const date = new Date(dup.data);
      dup.dataDisplay = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      dup.modal = false;
      const diaDaSemana = date.getDay();
      this.filtrarHorariosDuplicacao(idx, diaDaSemana);
    },
    async filtrarHorariosDuplicacao(idx, diaDaSemana) {
      const dup = this.duplicacoesAdicionais[idx];
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          dup.horariosFiltrados = [];
          return;
        }
        let horariosDoDia = [];
        if (diaDaSemana === 5) {
          horariosDoDia = await this.$services.horariosService.horariosAll();
        } else {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }
        dup.horariosFiltrados = horariosDoDia;
      } catch (error) {
        dup.horariosFiltrados = [];
      }
    },
    selecionarHorarioDuplicacao(idx, horario) {
      if (horario?.id && this.duplicacoesAdicionais[idx].data) {
        const dup = this.duplicacoesAdicionais[idx];
        const emUsoEmOutraLinha = this.duplicacoesAdicionais.some(
          (d, i) => i !== idx && d.data === dup.data && d.horario?.id === horario.id
        );
        const emUsoNaLinhaPrimaria =
          this.dataAulaDuplicada === dup.data && this.horarioSelecionado?.id === horario.id;
        if (emUsoEmOutraLinha || emUsoNaLinhaPrimaria) {
          this.$toast.danger(
            "Esta data e horário já estão sendo usados em outra aula desta duplicação."
          );
          this.$set(this.duplicacoesAdicionais[idx], "horario", null);
          return;
        }
      }
      this.$set(this.duplicacoesAdicionais[idx], "horario", horario);
      this.verificarConflitoDuplicacao(idx);
    },
    async verificarConflitoDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data || !dup.horario?.id) {
        dup.temConflito = false;
        return;
      }
      try {
        const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
          dup.data,
          dup.horario.id,
          this.gestaoDeAulas.turma_id,
          null
        );
        if (response.data.length > 0) {
          dup.horario = null;
          dup.temConflito = true;
          this.aulasEmConflito = response.data;
          this.sheetAulasEmConflito = true;
        } else {
          dup.temConflito = false;
        }
      } catch (error) {
        dup.temConflito = false;
      }
    },
    async verificarConflitoAula() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado?.id) {
        this.aulasEmConflito = [];
        this.temConflito = false;
        return;
      }

      try {
        const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
          this.dataAulaDuplicada,
          this.horarioSelecionado.id,
          this.gestaoDeAulas.turma_id,
          null
        );

        if (response.data.length > 0) {
          this.horarioSelecionado = null;
          this.aulasEmConflito = response.data;
          this.temConflito = true;
          this.sheetAulasEmConflito = true;
        } else {
          this.aulasEmConflito = [];
          this.temConflito = false;
        }
      } catch (error) {
        this.aulasEmConflito = [];
        this.temConflito = false;
      }
    },
    formatTexto(texto) {
      if (!texto) return "";
      const textoSemColchetes = texto.replace(/\[|\]/g, "");
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, "");
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>");
      return textoFormatado.trim() || "- - -";
    },
    tryParseHabilidades(valor) {
      if (Array.isArray(valor)) return valor;
      if (typeof valor !== "string") return null;
      const trimmed = valor.trim();
      if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return null;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : null;
      } catch (error) {
        return null;
      }
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          const todosHorarios = await this.$services.horariosService.horariosAll();
          horariosDoDia = todosHorarios;
        } else {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (this.data && this.horarioSelecionado.id) {
        const dupInvalida = this.duplicacoesAdicionais.some(
          (dup) =>
            !dup.data || (this.aulaDuplicada.tipo_de_aula !== "Aula Remota" && !dup.horario?.id)
        );
        if (dupInvalida) {
          this.$toast.danger("Por favor, preencha todos os campos das aulas adicionadas.");
          return;
        }
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      } else {
        this.$toast.danger("Por favor, preencha todos os campos");
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando as Aulas");
      try {
        const basePayload = {
          ...this.aulaDuplicada,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
          disciplina_id: this.gestaoDeAulas.disciplina_id,
          turma_id: this.gestaoDeAulas.turma_id,
          instrutor_id: this.gestaoDeAulas.instrutor_id,
        };

        if (Array.isArray(basePayload.disciplinas)) {
          basePayload.disciplinas = basePayload.disciplinas.map((d) =>
            typeof d === "object" ? d.id : d
          );
        }
        if (basePayload.habilidades && typeof basePayload.habilidades === "object") {
          basePayload.habilidades = JSON.stringify(basePayload.habilidades);
        }

        // Verifica conflito da aula principal
        const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
          this.dataAulaDuplicada,
          this.horarioSelecionado.id,
          this.gestaoDeAulas.turma_id,
          null
        );
        if (response.data.length > 0) {
          this.$toast.danger("Já existe uma aula cadastrada para essa data");
          this.$loaderService.close();
          return;
        }

        // Cria aula principal
        await this.$services.aulasService.criar({
          ...basePayload,
          horario_inicial: this.horarioSelecionado?.inicio ?? null,
          horario_final: this.horarioSelecionado?.final ?? null,
          horario_id: this.horarioSelecionado?.id ?? null,
          data: this.dataAulaDuplicada,
        });

        await this.duplicacoesAdicionais.reduce(
          (chain, dup) =>
            chain.then(() =>
              this.$services.aulasService.criar({
                ...basePayload,
                horario_inicial: dup.horario?.inicio ?? null,
                horario_final: dup.horario?.final ?? null,
                horario_id: dup.horario?.id ?? null,
                data: dup.data,
              })
            ),
          Promise.resolve()
        );
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        const total = 1 + this.duplicacoesAdicionais.length;
        this.$toast.success(
          total === 1 ? "Aula duplicada com sucesso!" : `${total} aulas duplicadas com sucesso!`
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },

  computed: {
    limiteAtingido() {
      return this.duplicacoesAdicionais.length >= 4;
    },
    itemsProgresso() {
      if (this.duplicacoesAdicionais.length === 0) return this.itemsEsperados;
      const isRemota = this.aulaDuplicada.tipo_de_aula === "Aula Remota";
      const total = 1 + this.duplicacoesAdicionais.length;
      const currentData =
        (this.dataAulaDuplicada ? 1 : 0) +
        this.duplicacoesAdicionais.reduce((sum, d) => sum + (d.data ? 1 : 0), 0);
      const items = [
        { label: "Data", value: "dataAulaDuplicada", count: { current: currentData, total } },
      ];
      if (!isRemota) {
        const currentHorario =
          (this.horarioSelecionado?.id ? 1 : 0) +
          this.duplicacoesAdicionais.reduce((sum, d) => sum + (d.horario?.id ? 1 : 0), 0);
        items.push({
          label: "Horário",
          value: "horarioSelecionado",
          count: { current: currentHorario, total },
        });
      }
      return items;
    },
    parsedHabilidades() {
      const parsed = this.tryParseHabilidades(this.aulaDuplicada.habilidades);
      return parsed || [];
    },

    uniqueUnidadesTematicas() {
      if (this.parsedHabilidades.length > 0) {
        const unidades = this.parsedHabilidades.map((h) => h.unidades_tematicas).filter(Boolean);
        return [...new Set(unidades)];
      }
      return [];
    },

    uniqueObjetosConhecimento() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.objeto_conhecimento).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },

    unidadesTematicasTexto() {
      if (this.aulaDuplicada.unidades_tematicas) return this.aulaDuplicada.unidades_tematicas;
      if (this.uniqueUnidadesTematicas.length > 0) return this.uniqueUnidadesTematicas.join("\n");
      return "";
    },
    objetosConhecimentoTexto() {
      if (this.aulaDuplicada.objeto_conhecimento) return this.aulaDuplicada.objeto_conhecimento;
      if (this.uniqueObjetosConhecimento.length > 0) {
        return this.uniqueObjetosConhecimento.join("\n");
      }
      return "";
    },
    habilidadesTexto() {
      const parsed = this.tryParseHabilidades(this.aulaDuplicada.habilidades);
      if (!parsed && typeof this.aulaDuplicada.habilidades === "string") {
        return this.aulaDuplicada.habilidades;
      }
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed
          .map((h) => {
            const apelido = h?.apelido ? `[${h.apelido}] ` : "";
            const descricao = h?.descricao || "";
            return `${apelido}${descricao}`.trim();
          })
          .filter((item) => item)
          .join("\n");
      }
      return "";
    },
  },
};
</script>
<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
.content-box {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
</style>
